export default {
  'setVariable.title': 'Set Variables',

  'setVariable.form.sourceForm': 'Source Form',
  'setVariable.form.sourceField': 'Source Field',
  'setVariable.form.formFieldValueSource': 'Field Value Source',
  'setVariable.form.variable': 'Variable',

  'setVariable.form.valueSource': 'Value Source',
  'setVariable.form.valueDestination': 'Value Destination',
  'setVariable.form.sourceVariable': 'Source Variable',
  'setVariable.form.destinationDynamicEntity': 'Destination Entity',
  'setVariable.form.destinationDynamicEntityField': 'Destination Entity Field',
  'setVariable.form.form': 'Form',
  'setVariable.form.field': 'Field',
  'setVariable.form.formula': 'Formula',
  'setVariable.form.fixedValue': 'Fixed Value',
  'setVariable.form.internalField': 'Internal Field',

  'setVariable.form.parameterValueFilterComparisonOperator': 'Filter Operator',
  'setVariable.form.parameterValueFilter': 'Parameter Filter Value',

  'setVariable.form.formFieldValueDestination': 'Field Value Destination',

  'setVariable.form.tableParameterName': 'List Parameter Name',
  'setVariable.form.parameterName': 'Parameter Name',
  'setVariable.form.attachmentFileName': 'Attachment Name',
  'setVariable.form.attachmentContentType': 'Content Type',

  'setVariable.form.select.FormField': 'Form / Field',
  'setVariable.form.select.Variable': 'Variable',
  'setVariable.form.select.EntityField': 'Entity Field',

  'setVariable.form.select.Formula': 'Formula',
  'setVariable.form.select.FixedValue': 'Fixed Value',
  'setVariable.form.select.InternalField': 'Internal Field',
  'setVariable.form.select.IterationStepData': 'Iteration / Data',
  'setVariable.form.select.GeneratedDocument': 'Generated Document',

  'setVariable.form.select.FieldValue': 'Display Value',
  'setVariable.form.select.FieldSearchValue': 'Search Value',

  'setVariable.form.select.ProcessIdentifier': 'Process - Internal Identifier',
  'setVariable.form.select.ProcessName': 'Process - Name',
  'setVariable.form.select.ProcessGroupName': 'Process Group - Name',
  'setVariable.form.select.InstanceName': 'Request - Name',
  'setVariable.form.select.InstanceCreated': 'Request - Creation Date',
  'setVariable.form.select.InstanceStatus': 'Request - Status',
  'setVariable.form.select.ApplicantFullName': 'Applicant - Full Name',
  'setVariable.form.select.InstanceApprovedDate': 'Request - Approval Date',
  'setVariable.form.select.InstanceRejectedDate': 'Request - Rejection Date',
  'setVariable.form.select.ApplicantNames': 'Applicant - First Names',
  'setVariable.form.select.ApplicantLastNames': 'Applicant - Last Names',
  'setVariable.form.select.ApplicantEmail': 'Applicant - Email',
  'setVariable.form.select.ApplicantPosition': 'Applicant - Position',
  'setVariable.form.select.InstanceIdentifier': 'Request - Internal Identifier',
  'setVariable.form.select.InstanceLastInstanceRejectUsers': 'Request - Last Step Rejecting Users',
  'setVariable.form.select.InstanceLastInstanceApproversUsers':
    'Request - Last Step Approving Users',
  'setVariable.form.select.InstanceRejectedReason': 'Request - Rejection Reason',
  'setVariable.form.select.InstanceApprovalRemarks': 'Request - Approval Remarks',
  'setVariable.form.select.InstanceCancellationDate': 'Request - Cancellation Date',
  'setVariable.form.select.InstanceCancellationReason': 'Request - Cancellation Reason',
  'setVariable.form.select.InstanceDetailsViewUrl': 'Request - Details View Url',

  'setVariable.form.sourceDocumentTemplate': 'Source Document Template',

  'setVariable.mapping': 'Mapping',
  'setVariable.addMapping': 'Add mapping',
  'setVariable.noMappings': 'No mappings configured.',
};
